import * as React from 'react';

import { compose } from 'recompose';
import connectToStores from 'vendor/cnpm/fluxible.v0-4/addons/connectToStores';

import Retracked from 'js/app/retracked';

import PageFooter from 'bundles/page-footer/components/PageFooter';
import PageHeader from 'bundles/page-header/components/PageHeader';
import type { Stores } from 'bundles/seo-entity-page/appEnv';

import 'css!../__styles__/index';

type Props = {
  requestCountryCode?: string | null;
  csrfToken?: string | null;
};

const SeoSearchApp: React.SFC<Props> = ({ children }) => (
  <div className="rc-SeoSearchApp">
    <PageHeader />
    {children}
    <PageFooter />
  </div>
);

export default compose<Props, {}>(
  Retracked.createTrackedContainer(() => ({
    namespace: {
      app: 'seo_entity_page',
      page: 'search',
    },
  })),
  connectToStores<Props, {}, Stores>(['ApplicationStore'], ({ ApplicationStore }, props) => ({
    ...props,
    csrfToken: ApplicationStore.getState().csrfToken,
    requestCountryCode: ApplicationStore.getState().requestCountryCode,
  }))
)(SeoSearchApp);
